import Api from './api';

const AtoService = {


    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/ato/listar',
            params: params
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/ato/buscar?${params}`)
        return response
    },
    categorias: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/ato/categorias',
            params: params
        })
        return response
    }
}

export default AtoService;